import React from 'react';
import { REACT_PK} from "../../../config";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

import CheckoutForm from './CardSetupForm';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
// const stripePromise = loadStripe("pk_test_51Kr8rAF1003CDINHHAtGRXLFhoQEXYN6pHTlATpROB7FEMwiMDAhTT4ZESfnFj11Y3dS1QzmH5YPUA3kaGLnA04h00b3CF4klh");
const stripePromise = loadStripe(REACT_PK);

export default function App(props) {

  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm 
        {...props}
      />
 </Elements>
  );
};
